import { PaymentElement } from '@stripe/react-stripe-js'
import { PaymentMethodEnum } from 'common/enums/PaymentMethodEnum'
import usePayment from 'publisher/hooks/usePayment'
import { setStripePaymentMethod } from 'publisher/store/payment/paymentActions'
import {
  getActiveStripePaymentMethod,
  getPaymentMethods,
} from 'publisher/store/payment/paymentSelectors'
import React from 'react'
import { useAppDispatch } from 'src/publisher/hooks/use-app-dispatch'

export const StripePaymentElement = () => {
  const dispatch = useAppDispatch()
  const stripePaymentMethod = usePayment(getActiveStripePaymentMethod)
  // const availablePaymentMethods = usePayment(getPaymentMethods)
  // const isApplePayEnabled = availablePaymentMethods.includes(
  //   PaymentMethodEnum.StripeApplepay,
  // )
  const isNameRequired =
    stripePaymentMethod === PaymentMethodEnum.StripeIDeal ||
    stripePaymentMethod === PaymentMethodEnum.StripeBancontact ||
    stripePaymentMethod === PaymentMethodEnum.StripeKlarna
  return (
    <PaymentElement
      onChange={e => dispatch(setStripePaymentMethod(`stripe:${e.value.type}`))}
      options={{
        layout: 'accordion',
        //https://app.shortcut.com/systeme/story/73336/revert-stripe
        // wallets: {
        //   // Respect page configuration for Apple Pay visibility
        //   applePay: isApplePayEnabled ? 'auto' : 'never',
        // },
        fields: {
          billingDetails: {
            email: 'never',
            ...(isNameRequired ? { name: 'never' } : {}),
            // https://app.shortcut.com/systeme/story/73336/revert-stripe
            // address: {
            //   country: 'never',
            // },
          },
        },
        terms: {
          card: 'never',
          applePay: 'never',
          bancontact: 'never',
          ideal: 'never',
        },
      }}
    />
  )
}
